// ErrorMessage.js
import React from 'react';
import { Paper, Typography } from '@mui/material';

const ErrorMessage = ({ message }) => {
  return (
    <Paper elevation={3} style={{ padding: '16px' }}>
      <Typography variant="h6" component="h2">
        Error
      </Typography>
      <Typography component="p">
        {message}
      </Typography>
    </Paper>
  );
};

export default ErrorMessage;
